import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/users')({
    beforeLoad: ({ location }) => {
        // Redirect to new members route
        throw redirect({
            to: '/members',
            search: location.search,
        });
    },
});
